import React, { useState } from "react";
import "../styles/Navbar.css";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/navlogo.png";
import menu from "../assets/menu.svg"
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const logoutHandler = (action) => {
    localStorage.clear();
    if (action === "provider") {
      navigate("/provider-login");
    } else if (action === "user") {
      navigate("/login");
    }
  };

  const handleClick = () => {
    navigate("/");
  };

  let getAuth = localStorage.getItem("data");
  getAuth = JSON.parse(getAuth);
  //console.loggetAuth, "getAuth");

  return (
    <nav className="navbar">
      <div className="logo">
        <Link
          to="/"
          onClick={handleClick}
          className="logo text-decoration-none"
        >
          <img src={logo} alt="Left Panel Image" />
        </Link>
      </div>
      <ul className="nav-links">
        {!!getAuth && getAuth.role === "user" && (
          <>
            <li>
              <Link to="/">Home</Link>
            </li>
          </>
        )}
        {!!getAuth && getAuth.role === "provider" && (
          <>
            <li>
              <Link to="/provider-business/new">List Your Space</Link>
            </li>
          </>
        )}


        {(!getAuth?.role || getAuth.role === "user") && (
          <li>
            <a href="" onClick={() => logoutHandler("provider")}>
              List Your Space
            </a>
          </li>
        )}
        <li>
          <Link to="/community">Community Board</Link>
        </li>
        <li>
          <Link to="/faq">Tenant Support</Link>
        </li>
        <li className="hamburger-menu" onClick={toggleMenu}>
          <div >
          <img src={menu} alt="" />
          </div>
          {isOpen && (
            <div className="menu-options">
              <ul>
                <li>
                  <Link to="/about">About Us</Link>
                  <hr />
                </li>
                {!!getAuth && getAuth?.role === "user" && (
                  <>
                    <li>
                      <Link to="/user-profile">My Profile</Link>
                      <hr />
                    </li>
                    <li>
                      <Link to="/property-favourite">My Favourite</Link>
                      <hr />
                    </li>
                    <li>
                      <Link
                        to={
                          getAuth?.role === "provider"
                            ? "/provider-update-password"
                            : "/update-password"
                        }
                      >
                        Change Password
                      </Link>
                      <hr />
                    </li>
                  </>
                )}
                {!!getAuth && getAuth?.role === "provider" && (
                  <li>
                    <Link to="/provider-profile">My Profile</Link>
                    <hr />
                  </li>
                )}
                <li>
                  <Link to="/contact">Contact us</Link>
                  <hr />
                </li>

                {getAuth && getAuth.role === "provider" && (
                  <>
                    <li>
                      <Link to="/provider-listing">My Listing</Link>
                      <hr />
                    </li>
                    <li>
                      <Link to="/provider-update-password">
                        Change Password
                      </Link>
                      <hr />
                    </li>
                  </>
                )}

                {!!getAuth?.jwt ? (
                  <li>
                    <a
                      className="logoutBtn"
                      onClick={() =>
                        logoutHandler(
                          getAuth?.role === "user" ? "user" : "provider"
                        )
                      }
                    >
                      Logout
                    </a>
                  </li>
                ) : (
                  <li>
                    <Link to="/login">Login</Link>
                  </li>
                )}
              </ul>
            </div>
          )}
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
